import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import { FilterSelect, Link } from '@warrenbrasil/nebraska-web';

import {
  getOrderFilters,
  IFilters
} from '@/modules/wealth/services/wealth-orders';
import { IFormattedFilters } from '@/modules/wealth/views/WealthPortfolioV2/components/Orders/types';

interface Props {
  disabled?: boolean;
}

interface Emit {
  (
    event: 'on-filter-select',
    filters: { direction: string; period: string }
  ): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
    disabled: { type: Boolean, default: false }
  },
  emits: ["on-filter-select"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'on-filter-select',
    filters: { direction: string; period: string }
  ): void;
}), expose: any, slots: any, attrs: any }) {





const isLoading = ref(true);
const hasError = ref(false);
const filters = ref<IFilters[] | null>(null);
const filtersData = ref<IFormattedFilters[] | null>(null);

const hasAppliedFilters = computed(() => {
  return filtersData.value?.some(filter => !!filter.value);
});

async function fetchOrderFilters() {
  isLoading.value = true;
  hasError.value = false;
  try {
    const data = await getOrderFilters();

    filters.value = data.filters;

    filtersData.value = formattedFilters(data.filters);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

function formattedFilters(data: IFilters[]) {
  const formatted = data.map(filter => {
    return {
      value: '',
      label: filter.filterName,
      parameter: filter.parameterName,
      options: filter.filters.map(option => {
        return {
          label: option.formatted,
          value: option.value
        };
      })
    };
  });

  return formatted.filter(filter => filter.parameter !== 'portfolioApiId');
}

function handleChange(value: string, index: number) {
  filtersData.value![index].value = value;

  const emitFilters = {
    direction: filtersData.value![0].value,
    period: filtersData.value![1].value
  };

  emit('on-filter-select', emitFilters);
}

function clearFilters() {
  filtersData.value = formattedFilters(filters.value!);

  const emitFilters = {
    direction: '',
    period: ''
  };

  emit('on-filter-select', emitFilters);
}

onMounted(async () => {
  await fetchOrderFilters();
});

return { __sfc: true,emit, isLoading, hasError, filters, filtersData, hasAppliedFilters, fetchOrderFilters, formattedFilters, handleChange, clearFilters, FilterSelect, Link }
}

})